export type AuthConfig = {
  pages: {
    home: string;
    authHome: string;
    login: string;
    signup: string;
    forgot: string;
    reset: string;
    verify: string;
    verifyToken: string;
    security: string;
  };

  adminUsers: string[];
};

const authConfig: { config: AuthConfig } = {
  config: {
    pages: {
      home: '/',
      authHome: '/',
      login: '/login',
      signup: '/signup',
      forgot: '/forgot',
      reset: '/reset[[...token]]',
      verify: '/verify',
      verifyToken: '/verify/[[...token]]',
      security: '/user/settings/security',
    },

    adminUsers: [],
  },
};

export default authConfig;
